<template>
  <div style="width: 1000px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" >
      <el-tab-pane label="会员登录" name="first" style="text-align: left;padding-top: 10px">
        <div style="width: 500px;margin: 0 auto">
          <el-form ref="form" :model="form" >
            <el-form-item label="账号" label-width="60px">
              <el-input v-model="form.username" ></el-input>
            </el-form-item>
            <el-form-item label="密码" label-width="60px">
              <el-input v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="验证码" label-width="60px">
              <el-input v-model="form.yzm"></el-input>
              <div @click="refreshCode"><s-identify :identifyCode="identifyCode" ></s-identify></div>
            </el-form-item>
            <el-form-item style="width: 300px;" label-width="80px">
              <el-button type="primary" @click="onSubmit">登录</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: "Login",
  data(){
    return{
      tabPosition: 'left',
      activeName: 'first',
      form: {
        username: '',
        password: '',
        yzm: '',
      },
      identifyCodes: "1234567890",
      identifyCode: "",
    }
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
  },
  methods: {
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
          ];
      }
    },
    onSubmit() {
      if(this.form.username == ''){
        this.$message.error('账号不能为空')
        return
      }else if(this.form.password == ''){
        this.$message.error('密码不能为空')
        return
      }else if(this.form.yzm == ''){
        this.$message.error('验证码不能为空')
        return
      }else if(this.form.yzm.toLowerCase() !== this.identifyCode.toLowerCase()) {
        this.$message.error('请填写正确验证码')
        this.refreshCode()
        return
      }
      let params = {
        username: this.form.username,
        password: this.form.password,
      }
      this.axios.post('/api/index/login',params).then((response) => {
        if(response.data.code == 1){
          sessionStorage.setItem('token',response.data.data.token)
          sessionStorage.setItem('username',this.form.username)
          this.$message({
            showClose: true,
            type:'success',
            message:'登录成功',
            duration:2000
          })
          this.$router.push({path:'/'})
        }else{
          this.$message({
            showClose: true,
            type:'error',
            message:response.data.code,
            duration:2000
          })
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }
}
</script>

<style scoped>
.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.el-input {
  width: 200px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// src/components/view/Login.vue